<script setup>
const props = defineProps({
  isSearched: {
    type: Boolean,
    default: false,
  },
  isMobile: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['resetReport', 'search', 'save']);
</script>

<template>
  <div class="btn-box ml-auto">
    <button class="sBtn nor" type="button" @click="emit('resetReport', 'reset')">
      <i class="icon-restart">아이콘</i>초기화
    </button>
    <button class="sBtn" type="button" @click="emit('search')">
      <i class="icon-search" />조회하기
    </button>
    <button
      v-if="isMobile && isSearched"
      class="sBtn sBtn-outline"
      type="button"
      @click="emit('save')"
    >
      저장하기
    </button>
  </div>
</template>
